<div class="inline-glossary-heading mt_1">

</div>
<div class="mx-2-5 mb-1" *ngIf="contacts.length>0">
  <div class="my-1 glossary-content-heading">
    {{glossaryData.name}}
  </div>
  <div class="mt_0_5rem" *ngFor="let contact of contacts">
    <div>
    <span *ngIf="contact.type=='sec'" class="font-14 georgiaFont">{{secDefinition}}</span>
    <span *ngIf="contact.type=='sec'" class="mr_0_5rem ml-0-5">|</span>
    <span *ngIf="glossaryData.topic!=null && glossaryData.topic.length > 0" class="small-text-heading cursor-pointer right-Overlay mr_0_5rem" data-parent="inline-glossary" id="glossary-term-usage" [topicData]="contact" appHostListenerClick>{{glossaryTermUsage}}</span>
  </div>
    <span *ngIf="glossaryData.topic!=null && glossaryData.topic.length > 0">
      <span class="see-topic-s">{{seeTopics}}</span>
      <span *ngFor="let topic of glossaryData.seetopic; let i = index">
        &nbsp;
        <span class="small-text-heading right-Overlay mr_0_5rem cursor-pointer pdf-link itcBookFont" data-parent="inline-glossary" id="glossary-term-topic" [topicData]="topic.topicData" appHostListenerClick>{{topic.topic}}</span>
        <span *ngIf="i != (glossaryData.seetopic.length -1)">,</span>
      </span>
    </span>
    <span class="text-transform-uppercase bold topic font-black" *ngIf=" glossaryData.topic.length == 0">
      No Incoming Links
    </span>
  </div>
</div>

<div class="mx-2-5 mb-3-5 mt-2 glossary-content">
  <div [innerHTML]="glossaryData.body"  (contextmenu)="onRightClick($event)" (click)="OpenLink($event)">
  </div>
</div>


